import request from '@/api/request'

export function getUserCoupons(status) {
  return request.get('/api/mini/coupon/list', { params: { status } })
}

export function getAvailableCoupons(productId, orderAmount) {
  return request.get('/api/mini/coupon/available', { params: { productId, orderAmount } })
}

export function claimCoupon(couponId) {
  return request.post(`/api/mini/coupon/claim/${couponId}`)
}
